/* eslint-disable no-nested-ternary */
import React from 'react'

import SectionHeader from '../../components/SectionHeader/SectionHeader'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
import { ALLOWED_WORDS, replaceWordInString } from '../../utils/helpers'
import {
  blogQuoteStyling,
  contentColor,
  contentContainer,
  contentStyling,
  ctaContainer,
  headercontainer,
  headersContainer,
  quoteContainer,
  rowContainer,
  withContent,
} from './QuoteSection.module.css'

const NewQuoteSection = ({ component, lang, slice }) => {
  const {
    quotebackground,
    quotecontainerwidth,
    quotecontent,
    quoteheading,
    quotekicker,
  } = slice

  return (
    <SectionLayout
      backGround={quotebackground}
      containerwidth={quotecontainerwidth}
      extraContentClassName={
        component === 'categoryintro'
          ? ''
          : replaceWordInString(quotecontent, 'botox', ALLOWED_WORDS[lang])
          ? contentContainer
          : ctaContainer
      }
      extraContentFontClassName={contentColor}
      extraDescriptionClassName={
        component === 'blogqoute' ? blogQuoteStyling : contentStyling
      }
      extraHeaderClassName={quotecontent ? headercontainer : ''}
      extraHeadingClassName={contentColor}
      extraHeadingContainerClassName={
        quotecontent ? withContent : quoteContainer
      }
      extraKickerClassName={contentColor}
      heading={replaceWordInString(quoteheading, 'botox', ALLOWED_WORDS[lang])}
      kicker={replaceWordInString(quotekicker, 'botox', ALLOWED_WORDS[lang])}
      renderedContent={replaceWordInString(
        quotecontent,
        'botox',
        ALLOWED_WORDS[lang],
      )}
      withHeader
    >
      {component === 'categoryintro' && (
        <div className={headersContainer}>
          <SectionHeader
            extraClassName={rowContainer}
            extraContentClassName={contentColor}
            extraHeadingClassName={contentColor}
            heading={replaceWordInString(
              slice.heading1,
              'botox',
              ALLOWED_WORDS[lang],
            )}
            renderedContent={replaceWordInString(
              slice.content1,
              'botox',
              ALLOWED_WORDS[lang],
            )}
          />
          <SectionHeader
            extraClassName={rowContainer}
            extraContentClassName={contentColor}
            extraHeadingClassName={contentColor}
            heading={replaceWordInString(
              slice.heading2,
              'botox',
              ALLOWED_WORDS[lang],
            )}
            renderedContent={replaceWordInString(
              slice.content2,
              'botox',
              ALLOWED_WORDS[lang],
            )}
          />
        </div>
      )}
    </SectionLayout>
  )
}

export default NewQuoteSection
